<template>
  <div class="carousel-wrapper">
    <carousel :items="1" :nav="false">
      <template slot="prev"><span class="prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
      </svg></span></template>

      <div>
        <img src="https://static.univision.com/especiales/noticias/infografias/uvalde-extras/galeria/Jacklyn_Cazares.jpg">
        <h2>Jacklyn Cazares</h2>
      </div>

      <div class="">
        <img src="https://static.univision.com/especiales/noticias/infografias/uvalde-extras/galeria/Annabell_Rodriguez.jpg">
        <h2>Annabell Rodríguez</h2>
      </div>

      <div>
        <img src="https://static.univision.com/especiales/noticias/infografias/uvalde-extras/galeria/Makenna_Elrod.jpg">
        <h2>Makenna Elrod</h2>
      </div>

      <div>
        <img src="https://static.univision.com/especiales/noticias/infografias/uvalde-extras/galeria/Maite_Rodriguez.jpg">
        <h2>Maite Rodríguez</h2>
      </div>

      <div>
        <img src="https://static.univision.com/especiales/noticias/infografias/uvalde-extras/galeria/Jailah_Silguero.jpg">
        <h2>Jailah Silguero</h2>
      </div>

      <div>
        <img src="https://static.univision.com/especiales/noticias/infografias/uvalde-extras/galeria/Eliahana_Cruz.jpg">
        <h2>Eliahana Cruz</h2>
      </div>

      <template slot="next"><span class="next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
      </svg></span></template>

    </carousel>
    <div class="excerpt">
      Jacklyn Cazares, Annabell Rodríguez, Makenna Elrod, Maite Rodríguez, Jailah Silguero y Eliahana Cruz, todas amigas cercanas de Caitlyne Gonzales, murieron en la masacre. Chandan Khanna/Getty Images
    </div>
</div>
</template>

<style lang="scss">

  .carousel-wrapper {
    position: relative;
    width: 100%;
    max-width: 460px;
    margin: 0 auto;

    h2 {
      position: absolute;
      top: 0;
      left: 0;
      padding: 10px;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 41px;
      text-shadow: 0px 0px 11px #000;
    }

    .excerpt {
      font: 300 15px "Lato", sans-serif;
      width: 100%;
      position: relative;
      bottom: 0;
      right: 0;
      color: #747474;
      pointer-events: none;
      text-align: center;
      padding: 10px 15px;
    }

    .prev {
      position: absolute;
      top: 35vh;
      left: 0;
      z-index: 99;
    }

    .next {
      position: absolute;
      top: 35vh;
      right: 0;
      z-index: 99;
    }

    img {
      width: 100%;
      height: auto;
    }

    svg {
      overflow: hidden;
      vertical-align: middle;
      margin: 10px;
      fill: #fff;
      width: 32px;
      height: 32px;
    }
  }
</style>

<script>

import carousel from 'vue-owl-carousel'

export default {
    components: { carousel },
}

</script>